export const REFERER = {
  SHOPIFY: 'shopify_onboarding',
  AMAZON: 'amazon_onboarding',
  NONE: 'none',
};
